//
// ███████╗████████╗ █████╗ ████████╗███████╗
// ██╔════╝╚══██╔══╝██╔══██╗╚══██╔══╝██╔════╝
// ███████╗   ██║   ███████║   ██║   █████╗
// ╚════██║   ██║   ██╔══██║   ██║   ██╔══╝
// ███████║   ██║   ██║  ██║   ██║   ███████╗
// ╚══════╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚══════╝
//
const state = {

}

//
//  ██████╗ ███████╗████████╗████████╗███████╗██████╗ ███████╗
// ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝
// ██║  ███╗█████╗     ██║      ██║   █████╗  ██████╔╝███████╗
// ██║   ██║██╔══╝     ██║      ██║   ██╔══╝  ██╔══██╗╚════██║
// ╚██████╔╝███████╗   ██║      ██║   ███████╗██║  ██║███████║
//  ╚═════╝ ╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝
//
const getters = {

}

//
// ███╗   ███╗██╗   ██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ████╗ ████║██║   ██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ██╔████╔██║██║   ██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██║╚██╔╝██║██║   ██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║ ╚═╝ ██║╚██████╔╝   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝     ╚═╝ ╚═════╝    ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const mutations = {

}

//
//  █████╗  ██████╗████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ██╔══██╗██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ███████║██║        ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██╔══██║██║        ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║  ██║╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝  ╚═╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const actions = {

  /**
     * Start core update for all selected sites, if update is needed
     *
     * @param commit
     * @param dispatch
     * @param state
     * @param rootState
     */
  updateCoreForSelectedSites ({ commit, dispatch, state, rootState }) {
    let siteNames = []

    rootState.site.siteSelected.forEach((e) => {
      let site = rootState.site.sites.data.filter(elm => {
        return (elm.id === e && elm.data.core_need_update === 1)
      })

      if (site.length !== 0) {
        siteNames.push(site[0].data.name)
        dispatch('updateCoreForSite', e)
      }
    })

    if (siteNames.length === 0) {
      this._vm.$snotify.info('Non of the selected Sites needs a core update')
    } else {
      this._vm.$snotify.info('Core update for: ' + siteNames.join(', ') + ' started')
    }

    commit('site/unsetSelectAll', {}, { root: true })
  },

  /**
     * Update an core for a site
     *
     * @param dispatch
     * @param state
     * @param payload   site id
     *
     * @returns {Promise<any>}
     */
  updateCoreForSite ({ dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.axios.get('/api/site/' + payload + '/updatecore').then(
        response => {
          let result = {
            'data': response.data.data,
            'context': {
              'source': 'local',
              'type': 'site',
              'site_id': payload
            }
          }
          dispatch('site/updateLocalStore', result, { root: true })
          resolve(result)
        }
      ).catch((error) => {
        alert(error.response.data.message)

        reject(error)
      })
    })
  }
}

//
// ███████╗██╗  ██╗██████╗  ██████╗ ██████╗ ████████╗
// ██╔════╝╚██╗██╔╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝
// █████╗   ╚███╔╝ ██████╔╝██║   ██║██████╔╝   ██║
// ██╔══╝   ██╔██╗ ██╔═══╝ ██║   ██║██╔══██╗   ██║
// ███████╗██╔╝ ██╗██║     ╚██████╔╝██║  ██║   ██║
// ╚══════╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝
//
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
